import Modal from "../../../components/Modal";
import { fmt } from "../constants";

export default function ModalPagar({ aba, modalPagar, dataPag, setDataPag, confirmarPagamento, onFechar }) {
  if (!modalPagar) return null;

  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onFechar}>Cancelar</button>
      <button className="btn btn-primary" onClick={confirmarPagamento}>Confirmar</button>
    </>
  );

  return (
    <Modal title={aba==="pagar"?"Confirmar Pagamento":"Confirmar Recebimento"} onClose={onFechar} size="sm" footer={footer}>
      <div style={{fontSize:14,marginBottom:12}}>
        <strong>{modalPagar.descricao}</strong> — R$ {fmt(modalPagar.valor)}
      </div>
      <div className="form-group">
        <label className="form-label">Data do {aba==="pagar"?"pagamento":"recebimento"}</label>
        <input className="form-input" type="date" value={dataPag} onChange={e=>setDataPag(e.target.value)}/>
      </div>
    </Modal>
  );
}
